export default __webpack_public_path__ + "static/media/blog-oil-stain-002.57333817.jpg";